import { setPlayerBufferingState } from 'src/actions/player.actions.js'
import { onBufferStateChange } from 'src/audio/dashPlayer.js'

export default function dispatchBufferStateChanges(store) {
  onBufferStateChange(bufferingState => {
    store.dispatch(setPlayerBufferingState(bufferingState))
  })
}
